import React, { PureComponent } from 'react';
import ReactHintFactory from 'react-hint';
import MobileHintContent from './MobileHintContent';

const ReactHint = ReactHintFactory(React);

// Doesn't support programmatically toggling
// can be implemented after update to react-redux v6+
class MobileHint extends PureComponent {
  constructor(props) {
    super(props);

    this.renderContent = this.renderContent.bind(this);
    this.close = this.close.bind(this);

    this.onMoveStart = this.onMoveStart.bind(this);
    this.onMoveEnd = this.onMoveEnd.bind(this);

    this.state = {
      isScrolling: false,
    };
  }

  componentDidMount() {
    document.addEventListener('touchmove', this.onMoveStart);
    document.addEventListener('touchend', this.onMoveEnd);
  }

  componentWillUnmount() {
    document.removeEventListener('touchmove', this.onMoveStart);
    document.removeEventListener('touchend', this.onMoveEnd);
  }

  onMoveStart() {
    this.setState({ isScrolling: true });
  }

  onMoveEnd() {
    this.setState({ isScrolling: false });
  }

  close() {
    setTimeout(() => this.tooltip && this.tooltip.toggleHint(), 0);
  }

  renderContent = (target, content) => {
    const { onRenderContent } = this.props;

    if (!content) {
      return null;
    }

    return (
      <MobileHintContent onClose={this.close}>
        {onRenderContent ? onRenderContent(target, content) : content}
      </MobileHintContent>
    );
  };

  render() {
    const { isScrolling } = this.state;

    return (
      !isScrolling && (
        <ReactHint
          {...this.props}
          persist
          ref={(ref) => {
            this.tooltip = ref;
          }}
          onRenderContent={this.renderContent}
        />
      )
    );
  }
}

const HintFactory = ({ isMobile, ...rest }) => {
  const Hint = isMobile ? MobileHint : ReactHint;
  return <Hint {...rest} />;
};

export default HintFactory;
